module.exports = __webpack_public_path__ + "img/cover2.0e1f6d31.webp";